import { jsx as _jsx } from "react/jsx-runtime";
import { SkapaSkeleton, SkapaStatus } from '@inter-ikea-guida/skapa';
import { StyledAvailability } from './styles';
export const ProductHomeDelivery = (props) => {
    const { unavailableLabel, availableLabel, isAvailable } = props;
    if (props.isLoading) {
        return _jsx(SkapaSkeleton, { height: '14px', width: '80%' });
    }
    if (isAvailable === true) {
        return (_jsx(StyledAvailability, { "data-testid": 'product-home-delivery', children: _jsx(SkapaStatus, { statusColor: 'green', small: true, label: availableLabel, statusDotPosition: 'inline' }) }));
    }
    if (isAvailable === false) {
        return (_jsx(StyledAvailability, { "data-testid": 'product-home-delivery', children: _jsx(SkapaStatus, { statusColor: 'red', small: true, label: unavailableLabel, statusDotPosition: 'inline' }) }));
    }
    return _jsx(StyledAvailability, {});
};
//# sourceMappingURL=ProductHomeDelivery.js.map